import React, { useEffect, useRef, useState } from 'react';
import { CalendarPlus, ChevronDown } from 'lucide-react';
import { ADDRESS, VENUE, REGISTER_URL } from './data';

const TITLE = 'CONVERGE by EvalentX — Hackathon, AI Workshop & HR Conclave';
const DETAILS = `National-level 24-hour hackathon, AI & Agentic AI workshop and HR Conclave at ${VENUE}, in association with AARUUSH.\nRegister: ${REGISTER_URL}`;
const LOCATION = `${VENUE}, ${ADDRESS}`;
// 16 Nov 09:00 IST → 17 Nov 19:00 IST, in UTC
const START = '20261116T033000Z';
const END = '20261117T133000Z';

const googleUrl = () => `https://calendar.google.com/calendar/render?${new URLSearchParams({
  action: 'TEMPLATE', text: TITLE, dates: `${START}/${END}`, details: DETAILS, location: LOCATION, ctz: 'Asia/Kolkata',
})}`;

const esc = (s) => s.replace(/\\/g, '\\\\').replace(/([,;])/g, '\\$1').replace(/\n/g, '\\n');

const downloadIcs = () => {
  const ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//EvalentX//CONVERGE 2026//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH', 'BEGIN:VEVENT',
    'UID:converge-2026@evalentx.com', `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '')}`,
    `DTSTART:${START}`, `DTEND:${END}`, `SUMMARY:${esc(TITLE)}`, `DESCRIPTION:${esc(DETAILS)}`, `LOCATION:${esc(LOCATION)}`, `URL:${REGISTER_URL}`,
    'BEGIN:VALARM', 'TRIGGER:-P1D', 'ACTION:DISPLAY', 'DESCRIPTION:CONVERGE starts tomorrow', 'END:VALARM', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
  const url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
  const a = document.createElement('a');
  a.href = url;
  a.download = 'converge-2026.ics';
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const AddToCalendar = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (e.type === 'keydown' ? e.key === 'Escape' : !ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    document.addEventListener('keydown', close);
    return () => { document.removeEventListener('mousedown', close); document.removeEventListener('keydown', close); };
  }, [open]);
  const item = 'block w-full text-left px-4 py-3 text-xs font-extrabold uppercase tracking-wider hover:bg-[#D7FF38] transition-colors';
  return (
    <div ref={ref} className="relative" data-testid="add-to-calendar">
      <button type="button" onClick={() => setOpen((o) => !o)} aria-expanded={open} aria-haspopup="menu"
        className="cv-btn inline-flex items-center gap-2 px-5 py-4 text-sm font-extrabold uppercase tracking-wider border-2 border-[#111] bg-[#365CFF] text-white shadow-[4px_4px_0_#111]" data-testid="add-to-calendar-btn">
        <CalendarPlus size={16} /> Add to calendar <ChevronDown size={14} />
      </button>
      {open && (
        <div role="menu" className="absolute z-30 left-0 mt-2 w-64 bg-white border-2 border-[#111] shadow-[5px_5px_0_#111]" data-testid="add-to-calendar-menu">
          <a role="menuitem" href={googleUrl()} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} className={item} data-testid="calendar-google-link">Google Calendar ↗</a>
          <button role="menuitem" type="button" onClick={() => { downloadIcs(); setOpen(false); }} className={`${item} border-t-2 border-[#111]`} data-testid="calendar-ics-btn">Apple / Outlook (.ics)</button>
        </div>
      )}
    </div>
  );
};
